import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _css;
import { css } from '@emotion/react';
import { inlineNodeViewClassname } from '@atlaskit/editor-common/react-node-view';
import { ZERO_WIDTH_SPACE } from '@atlaskit/editor-common/utils';

// For reasoning behind styles, see comments in:
// ./getInlineNodeViewProducer -> portalChildren()

export var InlineNodeViewSharedStyles = css((_css = {}, _defineProperty(_css, ".".concat(inlineNodeViewClassname), {
  display: 'inline',
  userSelect: 'all',
  whiteSpace: 'nowrap',
  '& > *:not(.zeroWidthSpaceContainer)': {
    whiteSpace: 'pre-wrap'
  },
  '& > .assistive': {
    userSelect: 'none'
  }
}), _defineProperty(_css, '&.ua-safari', _defineProperty({}, ".".concat(inlineNodeViewClassname), {
  '::selection, *::selection': {
    background: 'transparent'
  }
})), _defineProperty(_css, "&.ua-chrome .".concat(inlineNodeViewClassname, " > span"), {
  userSelect: 'none'
}), _defineProperty(_css, ".".concat(inlineNodeViewClassname, "AddZeroWidthSpace"), {
  '::after': {
    content: "'".concat(ZERO_WIDTH_SPACE, "'")
  }
}), _css));